import { render, staticRenderFns } from "./LoadingModal.vue?vue&type=template&id=44a22091&scoped=true&"
import script from "./LoadingModal.vue?vue&type=script&lang=js&"
export * from "./LoadingModal.vue?vue&type=script&lang=js&"
import style0 from "./LoadingModal.vue?vue&type=style&index=0&id=44a22091&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a22091",
  null
  
)

export default component.exports